import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useGap", "message", "options"];
import { useContext, createElement } from 'react';
// @ts-expect-error untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
const DEFAULT_OPTIONS = {};
function FormattedMessage(_ref) {
  let {
      useGap = false,
      message,
      options = DEFAULT_OPTIONS
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  useContext(I18nHMRContext);
  const props = classNameFix(getPassThroughProps(Object.assign({
    useGap,
    message,
    options
  }, rest)));
  return /*#__PURE__*/createElement('i18n-string', props, getValue({
    useGap,
    message,
    options
  }, true));
}
FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.isI18nElement = true;

// Consumers spyOn() this function and we don't want to require the mock to have `displayName`, and `isI18nElement`
export default FormattedMessage;